export const PUBLIC_IS_BOT = process.env.NEXT_PUBLIC_IS_BOT === 'true'

export const SHOULD_NOINDEX_PLPS = process.env.NEXT_PUBLIC_SHOULD_NOINDEX_PLPS === 'true'
export const SHOULD_NOFOLLOW_PLPS = process.env.NEXT_PUBLIC_SHOULD_NOFOLLOW_PLPS === 'true'
